import React from "react";
import styled from "styled-components";
import "@fontsource/ibm-plex-mono";

const StoreSecurityContainer = styled.div`
  position: relative;
  background-color: white;
  padding-left: min(4%, 40px);
  padding-right: min(4%, 40px);
  padding-bottom: 3%;
`;

const Title = styled.h2`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
`;

const SectionTitle = styled.h3`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 18px;
  font-weight: 600;
  margin: 8px 0;
`;

const Text = styled.p`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-indent: 2.5em;
  text-align: justify;
`;

const ListItem = styled.li`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-align: justify;
`;

const UnorderedList = styled.ul`
  padding-left: 10px;
  @media(min-width: 1024px) {
    padding-left: 40px;
  }
`;

const OrderedList = styled.ol`
  padding-left: 10px;
  @media(min-width: 1024px) {
    padding-left: 40px;
  }
  counter-reset: item;

  li {
    display: block;
    counter-increment: item;
    padding-left: 2.5em;
    position: relative;
  }

  li::before {
    content: counters(item, ".") ". ";
    position: absolute;
    left: 0;
    text-align: right;
    white-space: nowrap;
  }

  li:has(h3) {
    padding-left: 1.5em;
    font-size: 18px;
    font-weight: 600;
  }
`;

const StoreSecurity: React.FC = () => {
  return (
    <StoreSecurityContainer>
      <Title>Політика конфіденційності</Title>

      <Text>
        Ласкаво просимо в інтернет-магазин Barkov Books цей сайт є власністю видавництва ТОВ «Сітон».
      </Text>
      <Text>
        Уважно прочитайте нашу Політику конфіденційності.
      </Text>
      <Text>
        Дана Політика конфіденційності роз'яснює наші правила збору, використання і поширення
        інформації, яку ви можете передати на наш сайт і діє для всього сайту barkovooks.com
      </Text>
      <Text>
        Користувач має всі права щодо захисту його персональних даних, які передбачені чинним
        законодавством України, зокрема, Законом України «Про захист персональних даних».
      </Text>
      <Text>
        У деяких випадках ми можемо публікувати окремі примітки про конфіденційність для певних
        розділів сайту.
      </Text>
      <Text>
        Якщо вам потрібна додаткова інформація про способи обробки ваших особистих даних на сайті
        barkovbooks.com, надішліть запит електронною поштою на адресу support@barkovbooks.com
      </Text>

      <SectionTitle>Політика обробки персональних даних</SectionTitle>
      <Text>
        Ця політика обробки персональних даних (далі – Політика) встановлює умови збору,
        зберігання, обробки, зміни, передачі, знищення (видалення) персональних даних наданих ТОВ
        «Сітон» (далі – Володілець), а також умови згоди на обробку персональних даних суб’єктів
        персональних даних.
      </Text>
      <Text>
        Ця Політика розроблена у відповідності до Закону України «Про захист персональних даних»
        (в редакції від 23.04.2021).
      </Text>

      <OrderedList>
        <ListItem>
          <SectionTitle>Терміни вжиті в цій Політиці означають наступне:</SectionTitle>
          <OrderedList>
            <ListItem>
              Володілець – юридична особа, яка надає послуги Суб’єкту з доступу до Сервісу «Barkov Books», здійснює Обробку персональних даних відповідно до мети та інших умов цієї Політики. Для виконання своїх зобов’язань перед Суб’єктом термін «Володілець» також включає будь-яких афілійованих осіб Володільця, які приймають на себе зобов’язання щодо правомірної Обробки та захисту персональних даних відповідно до умов цієї Політики. В розумінні Закону України «Про захист персональних даних» термін «Володілець» включає одержувача, володільця та розпорядника персональних даних.
            </ListItem>
            <ListItem>
              Сервіс «Bakov Books» - сукупність програмних засобів Володільця, які надають можливість користувачам таких програмних засобів здійснювати доступ до електронних примірників літературних творів та аудіо виконань літературних творів.
            </ListItem>
            <ListItem>
              Суб’єкт – фізична особа, користувач Сервісу «Barkov Boooks», яка надає свої персональні дані, а також безумовну згоду на Обробку персональних даних, шляхом завантаження та встановлення Сервісу «Barkov Books» на власний пристрій, проходження процедури реєстрації в Сервісі «Barkov Books», а також іншими способами визначеними в цій Політиці.
            </ListItem>
            <ListItem>
              Обробка – дії Володільця зі збирання, збереження, накопичення, зміна, використання та будь-яка інша обробка персональних даних, яка відповідає меті Обробки персональних даних та іншим умовам цієї Політики.
            </ListItem>
            <ListItem>
              Згода – добровільне волевиявлення Суб’єкта щодо надання дозволу на обробку своїх персональних даних Володільцю, здійснене шляхом: проставлення відповідної відмітки при реєстрації в Сервісі «Barkov Books», та/або проходженням процедури реєстрації в Сервісі «Barkov Books», та/або використанням будь-яких послуг Сервісу «Barkov Books», в тому числі здійснення будь-яких платежів за послуги Сервісу «Barkov Books».
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Умови обробки персональних даних</SectionTitle>
          <OrderedList>
            <ListItem>
              Суб’єкт персональних даних надає свою Згоду Володільцю на Обробку персональних даних, шляхом вчинення дій, передбачених п. 1.5. цієї Політики, за умови, що перед вчиненням таких дій в Суб’єкта є можливість повністю ознайомитися з умовами цієї Політики. Дії, передбачені п. 1.5. цієї Політики є гарантією повної цивільної дієздатності Суб’єкта персональних даних та повного розуміння ним умов цієї Політики.
            </ListItem>
            <ListItem>
              Метою Обробки персональних даних є забезпечення Володільцем можливості ідентифікації Суб’єктом власної інформації в Сервісі «Barkov Books», забезпечення можливості Суб’єкта здійснювати доступ до послуг Сервісу «Barkov Books», забезпечення можливості Суб’єкта на отримання технічної та консультативної підтримки щодо використання Сервісу «Barkov Books», а також забезпечення Володільцем надання послуг та виконання своїх зобов’язань відповідно до умов Публічної оферти перед Суб’єктом.
            </ListItem>
            <ListItem>
              Зміст персональних даних, Обробку яких здійснює Володілець складають відомості, які ідентифікують особу, а саме: прізвище, ім’я та по-батькові Суб’єкта; контактна інформація Суб’єкта (в тому числі адреса для листування, номер мобільного телефону та адреса електронної пошти); а також відомості, які допомагають покращити якість послуг, що надаються Володільцем в Сервісі «Barkov Books».
            </ListItem>
            <ListItem>
              Володілець може отримувати доступ до інших персональних даних Суб’єкта, не передбачених умовами цієї Політики таких як: технічні відомості щодо доступу Суб’єкта до Сервісу «Barkov Books», інформація про пристрій, який використовується Суб’єктом, інформація про інтереси та вподобання Суб’єкта в Сервісі «Barkov Books», інформація щодо геолокації пристрою Суб’єкта, тощо. Володілець може отримати доступ до вказаної вище інформації внаслідок нормальної взаємодії Сервісу «Barkov Books» з іншими програмними та апаратними складовими Суб’єкта. Щодо Обробки персональних даних, отриманих Володільцем відповідно до цього пункту встановлюються такі самі зобов’язання за цією Політикою як і щодо персональних даних, передбачених п. 2.1.3. цієї Політики.
            </ListItem>
            <ListItem>
              Володілець не здійснює Обробку платіжної інформації Суб’єкта, який останній використовує для оплати послуг Сервісу «Barkov Books». Обробка платіжної інформації Суб’єкта так само як забезпечення процесу оплати послуг Сервісу «Barkov Books» здійснюються сторонніми платіжними системами (третіми особами). Здійснюючи оплату послуг Сервісу «Barkov Books», Суб’єкт погоджується з умовами обробки персональних даних сторонніх платіжних систем (третіх осіб), які доступні Суб’єкту для ознайомлення до моменту оплати.
            </ListItem>
            <ListItem>
              Суб’єкт, відповідно до умов цієї Політики, надає Згоду на безстрокове зберігання персональних даних Володільцем до моменту отримання від Суб’єкта вимоги про відкликання дозволу та припинення Обробки персональних даних.
            </ListItem>
            <ListItem>
              Місцем обробки персональних даних є апаратні пристрої Володільця, розташовані за адресом, вказаним в реквізитах Володільця в п. 6.1. цієї Політики.
            </ListItem>
            <ListItem>
              Будь-які суттєві зміни умов цієї Політики, в тому числі мети, та порядку Обробки персональних даних супроводжуються обов’язковим повідомленням Суб’єкта персональних даних про такі зміни.
            </ListItem>
            <ListItem>
              Володілець персональних даних забезпечує належний рівень захисту персональних даних Суб’єкта на недопущення несанкціонованого поширення та розповсюдження персональних даних третім особам.
            </ListItem>
            <ListItem>
              Володілець має право надати дозвіл на Обробку персональних даних третім особам (неафілійованим особам Володільця) за умови отримання відповідного дозволу від Суб’єкта персональних даних.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Права Суб’єкта персональних даних</SectionTitle>
          <OrderedList>
            <ListItem>
              Відповідно до Закону України «Про захист персональних даних» та умов цієї Політики Суб’єкт персональних даних має право:
              <UnorderedList>
                <ListItem>
                  отримати інформацію про джерела збирання, місцезнаходження, склад та точний зміст своїх персональних даних;
                </ListItem>
                <ListItem>
                  отримати інформацію про мету, способи Обробки та Володільця своїх персональних даних;
                </ListItem>
                <ListItem>
                  пред’явити запит про відкликання згоди на Обробку своїх персональних даних;
                </ListItem>
                <ListItem>
                  пред’явити вмотивовану вимогу знищення (видалення) своїх персональних даних з місця зберігання персональних даних Володільця;
                </ListItem>
                <ListItem>
                  пред’явити вмотивовану вимогу Володільцю щодо внесення змін в склад, зміст та об’єм своїх персональних даних;
                </ListItem>
                <ListItem>
                  на інші способи захисту своїх персональних даних, відповідно до чинного законодавства України та умов цієї Політики.
                </ListItem>
              </UnorderedList>
            </ListItem>
            <ListItem>
              Реалізація прав Суб’єкта персональних даних, передбачених п. 3.1. цієї Політики можлива шляхом, надсилання Суб’єктом Володільцю відповідного звернення за реквізитами Володільця вказаними в п. 6.1. цієї Політики.
            </ListItem>
            <ListItem>
              Приймаючи умови цієї Політики, Суб’єкт персональних даних погоджується на отримання від Володільця інформаційних повідомлень, які відповідають меті Обробки персональних даних до моменту отримання Володільцем відмови Суб’єкта від отримання таких повідомлень.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Обмеження відповідальності Володільця</SectionTitle>
          <OrderedList>
            <ListItem>
              Володілець не несе відповідальності за негативні наслідки використання персональних даних Суб’єкта третіми особами, якщо таке використання сталося внаслідок недостатніх засобів захисту Суб’єктом своїх персональних даних.
            </ListItem>
            <ListItem>
              Володілець не несе відповідальності за негативні наслідки, внаслідок надання Суб’єктом персональних даних недостовірних відомостей.
            </ListItem>
            <ListItem>
              Володілець не несе відповідальності за негативні наслідки використання персональних даних Суб’єкта третіми особами, якщо таке використання відбулося внаслідок надання Суб’єктом дозволу на Обробку персональних даних третім особам.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Форс-мажорні обставини</SectionTitle>
          <Text>
            Обставини, що не залежать від волі Володільця та Суб’єкта і є невідворотними або надзвичайними за даних умов (форс-мажорні обставини), і які безпосередньо впливають на дотримання умов цієї Політики, унеможливлюючи належне виконання договірних обов’язків, виключають відповідальність сторони, для якої вони настали, за недотримання чи неналежне дотримання умов цієї Політики.
          </Text>
        </ListItem>

        <ListItem>
          <SectionTitle>Реквізити Володільця</SectionTitle>
          <Text>
            Товариство з обмеженою відповідальністю «Сітон»; код ЄДРПОУ: 33444251; адреса місцезнаходження: Україна, 04200, м. Київ, вул. Дубровицька, 28; адреса ел. пошти: support@barkovbooks.com
          </Text>
        </ListItem>
      </OrderedList>

      <SectionTitle>Файли cookie, інформація про відвідування</SectionTitle>
      <Text>
        Коли ви заходите на наш сайт, ми відправляємо один або декілька файлів cookie на ваш комп'ютер або інший пристрій. Файли cookie використовуються для того, щоб підвищувати якість надаваних послуг: зберігати налаштування користувача, відстежувати характерні для користувачів тенденції, наприклад, найпопулярніші сторінки. Barkovbooks.com також використовує файли cookie в рекламних службах, а також здійснює їх передачу, в тому числі транскордонну, щоб керувати оголошеннями на сайтах по всьому Інтернету.
      </Text>
      <Text>
        При доступі до нашого Сайту через браузер, додаток або інший клієнт наші сервери автоматично записують і передають з метою виконання укладених договорів певну інформацію. Ці журнали серверу можуть містити таку інформацію, як IP-адресу, тип і мова браузера, дата і час запиту, а також один або декілька файлів cookie, за якими можна визначити ваш браузер або обліковий запис.
      </Text>

      <SectionTitle>Інші сайти</SectionTitle>
      <Text>
        Дана політика конфіденційності стосується тільки сайту Barkovbooks.com. Ми не контролюємо сайти, які використовують інформацію з нашого сайту або на які ведуть посилання з нашого сайту. Ці сайти можуть розміщувати на Ваш комп'ютер власні файли cookie, збирати дані або запитувати у вас особисту інформацію.
      </Text>

      <SectionTitle>Інформаційні розсилки</SectionTitle>
      <UnorderedList>
        <ListItem>
          При реєстрації на Сайті ви даєте згоду на отримання від нас розсилок рекламно-інформаційного характеру. Зазначені розсилки містять інформацію про товари, майбутні акції, розіграші та інші заходи Сайту.
        </ListItem>
        <ListItem>
          Ви можете відмовитися від розсилки в будь-який момент, перейшовши за відповідним посиланням в листі або написавши в службу підтримки.
        </ListItem>
        <ListItem>
          Розсилки надходять у вигляді листа на електронну адресу та/або короткого повідомлення (sms) на номер телефону, які зазначені вами при реєстрації або у своєму Особистому кабінеті. Рекламно-інформаційні матеріали можуть надаватися у вигляді паперово-поліграфічної та сувенірної продукції, вкладатися в замовлення клієнтів і доставлятися на вказану поштову адресу у вигляді листів і посилок.
        </ListItem>
      </UnorderedList>
      <Text>
        Крім цього, інформація, що збирається нами може бути використана в наступних цілях:
      </Text>
      <UnorderedList>
        <ListItem>
          Постачання, підтримка, забезпечення захисту та удосконалення нашого Сайту, а також розробка нових служб. Захист прав і власності сайту barkovbooks.com і наших користувачів. Перед використанням інформації в інших цілях, крім тих, що були зазначені при її зборі, ми попросимо у вас дозволу на таке використання.
        </ListItem>
        <ListItem>
          Сайт barkovbooks.com обробляє особисту інформацію на своїх серверах в різних країнах. У деяких випадках особиста інформація користувачів обробляється за межами країни користувача.
        </ListItem>
      </UnorderedList>

      <SectionTitle>Надання доступу до інформації</SectionTitle>
      <Text>
        Ми не розкриваємо особисту інформацію користувачів компаніям, організаціям і приватним особам, які не пов'язані з сайтом barkovbooks.com, крім таких випадків:
      </Text>
      <UnorderedList>
        <ListItem>
          <strong>Користувач дав на це свою згоду</strong>
        </ListItem>
        <Text>
          Ми можемо надати відомості про вас компаніям, організаціям або приватним особам, які не пов'язані з сайтом yakaboo.ua, якщо ви надали на це згоду.
        </Text>
        <ListItem>
          <strong>Для обробки третіми сторонами</strong>
        </ListItem>
        <Text>
          Ми можемо надати особисту інформацію користувачів нашим афілійованим компаніям або іншим компаніям, які діють від нашого імені для обробки інформації від нашого імені. Ці компанії зобов'язані дотримуватися умов цієї Політики конфіденційності.
        </Text>
        <ListItem>
          <strong>На вимогу законодавства</strong>
        </ListItem>
        <Text>
          У нас є достатні підстави вважати, що доступ, використання, збереження або розкриття такої інформації розумним чином необхідні з метою:
        </Text>
        <UnorderedList>
          <ListItem>
            Дотримання будь-яких чинних законів, постанов, вимог юридичного процесу або дійсного запиту з державних органів.
          </ListItem>
          <ListItem>
            Дотримання чинних Умов продажу товарів та надання послуг, включаючи розслідування потенційних порушень.
          </ListItem>
          <ListItem>
            Виявлення і запобігання шахрайських дій, а також вирішення проблем безпеки та усунення технічних неполадок.
          </ListItem>
          <ListItem>
            Захисту від безпосередньої загрози заподіяння шкоди правам, власності або безпеки сайту barkovbooks.com, його користувачам або громадськості, як це вимагається або дозволяється законом.
          </ListItem>
        </UnorderedList>
      </UnorderedList>
      <Text>
        Якщо сайт barkovbooks.com візьме участь у злитті, придбанні або будь-якій іншій формі продажу частини або всіх своїх активів, ми гарантуємо збереження конфіденційності будь-якої особистої інформації, яка може бути залучена в цю угоду.
      </Text>

      <SectionTitle>Захист інформації</SectionTitle>
      <Text>
        Сайт barkovbooks.com здійснює належний захист Персональних і інших даних відповідно до Законодавства і приймає необхідні і достатні організаційні та технічні заходи щодо захисту Персональних даних від неправомірного або випадкового доступу, знищення, зміни, блокування, копіювання, розповсюдження, а також від інших неправомірних дій третіх осіб.
      </Text>

      <SectionTitle>Зміна персональних даних</SectionTitle>
      <UnorderedList>
        <ListItem>
          Користувач може в будь-який момент змінити (оновити, доповнити) Персональні дані в Особистому кабінеті або шляхом направлення письмової заяви на адресу support@barkovbooks.com
        </ListItem>
        <ListItem>
          Користувач в будь-який момент має право видалити Персональні дані шляхом направлення письмової заяви на адресу support@barkovbooks.com
        </ListItem>
        <ListItem>
          Користувач гарантує, що всі Персональні дані є актуальними і не відносяться до третіх осіб.
        </ListItem>
      </UnorderedList>

      <SectionTitle>Дотримання вимог</SectionTitle>
      <Text>
        Дана Політика конфіденційності відображає основні принципи використання інформації компанією «Сітон». Здійснюючи доступ на цей сайт, переглядаючи і використовуючи його, або надаючи компанії «Сітон» свою особисту інформацію, ви висловлюєте свою згоду з умовами цієї Політики конфіденційності. Якщо ви не згодні з цими умовами, просимо не надавати нам свою особисту інформацію.
      </Text>

      <SectionTitle>Ми регулярно перевіряємо дотримання даної Політики конфіденційності</SectionTitle>
      <Text>
        Отримавши офіційну скаргу в письмовій формі, ми вважаємо своїм обов'язком звернутися до користувача, що відправив скаргу з приводу його претензій або побоювань. Ми будемо співпрацювати з відповідними регулюючими органами, включаючи місцевих представників влади, що відповідають за захист даних, для вирішення питань передачі особистих даних, які неможливо вирішити між сайтом barkovbooks.com і приватною особою.
      </Text>

      <SectionTitle>Зміна політики конфіденційності</SectionTitle>
      <Text>
        Сайт barkovbooks.com вправі вносити зміни і доповнення до даної політики конфіденційності.
      </Text>
      <Text>
        Всі оновлення і доповнення політики конфіденційності публікуються на цій сторінці.
      </Text>
      <Text>
        Оновлена 1 вересня 2025 року.
      </Text>
    </StoreSecurityContainer>
  );
};

export default StoreSecurity;